import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import { Modal, Table, Icon, Button } from 'antd';
import { apis } from '../api/index.js';
import { eventListener } from '../utils';
const Diff = require('diff');

class HistoryList extends React.Component {
  static propTypes = {
    visible: PropTypes.bool.isRequired,
    onCancel: PropTypes.func.isRequired,
    history: PropTypes.object,
    reportInfo: PropTypes.object,
  };

  state = {
    historyList: [],
    productionId: '101',
  };
  componentDidUpdate(prevProps) {
    const { visible } = this.props;
    if (prevProps.visible !== visible && visible) this.getHistoryList();
  }

  getHistoryList = () => {
    const { reportInfo } = this.props;
    apis.reportHis(reportInfo.reportId, reportInfo.diagId).then(res => {
      if (res.code === '0') {
        const historyList = res.data;
        const stateArray = [22, 30, 42, 46]; //已审核;已打印;纠错后审核；纠错后已打印
        //取这几种状态的数据，并使用最新的一条作为比对条件
        let compareForm = historyList.filter(
          item => stateArray.indexOf(item.state) > -1
        );
        let hasReviewForm = compareForm.length > 0;
        if (compareForm.length > 0) compareForm = compareForm[0];

        this.setState({ historyList, hasReviewForm, compareForm });
      } else if (res.code === '1009') this.props.history.push('/login');
    });
  };
  //点击“取消按钮”隐藏对话框
  handleCancel = () => {
    const { productionId } = this.state;
    const { reportInfo } = this.props;
    const { state } = reportInfo;
    const eventData = { productionId };
    let [pageId, moduleId, elementId] = ['', '', ''];
    if (state === 11) {
      [pageId, moduleId, elementId] = ['10019', 'mk0001', 'ns-008'];
    } else if ([21, 26].includes(state)) {
      [pageId, moduleId, elementId] = ['10020', 'mk0001', 'ns-008'];
    } else {
      [pageId, moduleId, elementId] = ['10021', 'mk0001', 'ns-008'];
    }
    eventListener({ ...eventData, pageId, moduleId, elementId });

    this.props.onCancel(false);
  };

  getColumns = () => {
    const columns = [
      { title: '时间', dataIndex: 'createTime', key: 'createTime' },
      { title: '标题', dataIndex: 'title', key: 'title' },
      {
        title: '描述',
        key: 'printDisc',
        render: record => (
          <span>
            {record.printDisc}{' '}
            {record.printTime ? '打印时间：' + record.printTime : ''}
          </span>
        ),
      },
    ];
    return columns;
  };

  resetHistoryList = list => {
    list.forEach((item, index) => {
      item.title = '历史报告' + (index + 1);
    });
    return list;
  };

  compare = record => {
    const { compareForm, historyList, productionId } = this.state;
    const { reportInfo } = this.props;
    const { state } = reportInfo;
    const eventData = { productionId };
    let [pageId, moduleId, elementId] = ['', '', ''];
    if (state === 11) {
      [pageId, moduleId, elementId] = ['10019', 'mk0001', 'ns-011'];
    } else if (state === 21 || state === 26) {
      [pageId, moduleId, elementId] = ['10020', 'mk0001', 'ns-011'];
    } else {
      [pageId, moduleId, elementId] = ['10021', 'mk0001', 'ns-011'];
    }
    eventListener({ ...eventData, pageId, moduleId, elementId });

    const diffDiag = Diff.diffChars(
      record.diagnosisDescription,
      compareForm.diagnosisDescription
    );
    const diffRadio = Diff.diffChars(
      record.radiographyDescription,
      compareForm.radiographyDescription
    );

    const newForm = { ...compareForm };
    newForm.diagnosisDescription = diffDiag;
    newForm.radiographyDescription = diffRadio;
    historyList.forEach((item, index) => {
      if (item.id === newForm.id) historyList[index] = { ...newForm };
    });
    this.setState({ historyList });
  };

  disCompare = record => {
    const { compareForm, historyList, productionId } = this.state;
    const { reportInfo } = this.props;
    const { state } = reportInfo;
    const eventData = { productionId };
    let [pageId, moduleId, elementId] = ['', '', ''];
    if (state === 11) {
      [pageId, moduleId, elementId] = ['10019', 'mk0001', 'ns-012'];
    } else if (state === 21 || state === 26) {
      [pageId, moduleId, elementId] = ['10020', 'mk0001', 'ns-012'];
    } else {
      [pageId, moduleId, elementId] = ['10021', 'mk0001', 'ns-012'];
    }
    eventListener({ ...eventData, pageId, moduleId, elementId });

    const newForm = { ...compareForm };
    newForm.diagnosisDescription = compareForm.diagnosisDescription;
    newForm.radiographyDescription = compareForm.radiographyDescription;
    historyList.forEach((item, index) => {
      if (item.id === newForm.id) historyList[index] = { ...newForm };
    });
    this.setState({ historyList });
  };

  expandedRowRender = (record, index) => {
    const { hasReviewForm } = this.state;
    const radio = record.radiographyDescription;
    const diag = record.diagnosisDescription;
    return (
      <div className="history-detail">
        {index === 0 && hasReviewForm && (
          <Button
            icon="swap"
            size="small"
            shape="round"
            onClick={() => this.disCompare(record)}
          >
            取消
          </Button>
        )}
        {index !== 0 && hasReviewForm && (
          <Button
            icon="swap"
            size="small"
            shape="round"
            onClick={() => this.compare(record)}
          >
            对比
          </Button>
        )}

        <p>
          影像所见：
          {typeof radio === 'string' ? (
            radio
          ) : (
            <>
              {radio.map((item, index) => {
                const color = classNames({
                  green: item.added,
                  red: item.removed,
                });
                return (
                  <span className={color} key={index}>
                    {item.value}
                  </span>
                );
              })}
            </>
          )}
        </p>
        <p>
          诊断建议：
          {typeof diag === 'string' ? (
            diag
          ) : (
            <>
              {diag.map((item, index) => {
                const color = classNames({
                  green: item.added,
                  red: item.removed,
                });
                return (
                  <span className={color} key={index}>
                    {item.value}
                  </span>
                );
              })}
            </>
          )}
        </p>
        <p className="btn-disabled historylist-names">
          <span>申请医生：{record.applyUser}&nbsp;&nbsp; </span>
          <span>报告医生：{record.reportUser}&nbsp;&nbsp;</span>
          <span>审核医生1：{record.reviewUser}&nbsp;&nbsp;</span>
          {record.review2User && <span>审核医生2:{record.review2User}</span>}
          {record.printedModifyUser && (
            <span>纠错医生：{record.printedModifyUser}</span>
          )}
        </p>
      </div>
    );
  };
  onExpand = (expanded, record) => {
    const { reportInfo } = this.props;
    const { state } = reportInfo;
    const { productionId } = this.state;
    const eventData = { productionId };
    let [pageId, moduleId, elementId] = ['', '', ''];
    if (state === 11) {
      [pageId, moduleId] = ['10019', 'mk0001'];
    } else if (state === 21 || state === 26) {
      [pageId, moduleId] = ['10020', 'mk0001'];
    } else {
      [pageId, moduleId] = ['10021', 'mk0001'];
    }
    elementId = expanded ? 'ns-009' : 'ns-010';
    eventListener({ ...eventData, pageId, moduleId, elementId });
  };
  render() {
    let { historyList } = this.state;
    historyList = this.resetHistoryList(historyList) || [];
    const columns = this.getColumns();
    const { visible } = this.props;
    return (
      <div className="group-modal">
        <Modal
          title="历史报告列表"
          visible={visible}
          width={'50%'}
          height={'60%'}
          ref={this.modal}
          className="group-manager"
          onCancel={this.handleCancel}
          centered={true}
          keyboard={false}
          maskClosable={false}
          footer={null}
        >
          <div className="history-list-content">
            <p className="history-list-title">
              <Icon type="file-text" theme="filled" />共{historyList.length}
              份历史报告
            </p>
            <Table
              columns={columns}
              expandedRowRender={(record, index) =>
                this.expandedRowRender(record, index)
              }
              onExpand={this.onExpand}
              dataSource={historyList}
              rowKey={record => record.id}
              key={record => record.id}
              showHeader={false}
              pagination={false}
              expandRowByClick={true}
            />
          </div>
        </Modal>
      </div>
    );
  }
}

export default HistoryList;
